import { requestLogout } from 'components/LogoutConfirm/LogoutConfirm';
import { MessagesSquare, Search, Settings, Star, UserRound } from 'lucide-react';
import type React from 'react';
import { NavLink } from 'react-router';

import { RoleSwitcher } from 'components/Header/RoleSwitcher';
import { useProfileModeration } from 'hooks/useProfileModeration';
import { ChatReportMenuButton } from 'modules/ChatV2/components/ChatReportMenuButton';

import { DrawerLogo } from './DrawerLogo';
import styles from './MobileDrawer.module.scss';

interface TeacherMobileNavProps {
  onNavigate?: () => void;
}

// Иконки - тот же набор lucide, что в боковом меню (Figma 3:30077).
const primaryItems = [
  { to: '/teacher', label: 'Мой профиль', end: true, Icon: UserRound },
  { to: '/teacher/search', label: 'Поиск', Icon: Search },
  { to: '/teacher/chat', label: 'Чаты и отклики', Icon: MessagesSquare },
  { to: '/teacher/settings', label: 'Настройки', Icon: Settings },
  { to: '/teacher/trust-score', label: 'Рейтинг', Icon: Star },
];

const secondaryItems = [
  { to: '/teacher/questions', label: 'Частые вопросы' },
  { to: '/teacher/help', label: 'Тех.поддержка' },
];

export const TeacherMobileNav: React.FC<TeacherMobileNavProps> = ({ onNavigate }) => {
  const { isApproved } = useProfileModeration();

  const handleLogout = () => {
    onNavigate?.();
    requestLogout();
  };

  return (
    <>
      <DrawerLogo accent='teacher' onNavigate={onNavigate} />
      <div className={styles.roleSwitcher}>
        <RoleSwitcher variant='menu' />
      </div>
      <ul className={styles.navList}>
        {primaryItems.map(({ to, label, end, Icon }) => {
          const locked = !isApproved && (to === '/teacher/search' || to === '/teacher/chat');
          return (
          <li key={to} className={styles.navItem}>
            {locked ? (
              <div className={styles.navLocked}>
                <span className={styles.navLockedName}>
                  <Icon className={styles.navIcon} aria-hidden='true' />
                  {label}
                </span>
                <span className={styles.navLockedHint}>Доступно после одобрения профиля</span>
              </div>
            ) : (
            <NavLink
              to={to}
              end={end}
              onClick={onNavigate}
              className={({ isActive }) =>
                `${styles.navLink} ${isActive ? styles['navLink--active'] : ''}`
              }
            >
              <Icon className={styles.navIcon} aria-hidden='true' />
              {label}
            </NavLink>
            )}
          </li>
          );
        })}
      </ul>
      <div className={styles.navDivider} />
      <ul className={`${styles.navList} ${styles.navListSecondary}`}>
        {secondaryItems.map(({ to, label }) => (
          <li key={to} className={styles.navItem}>
            <NavLink
              to={to}
              onClick={onNavigate}
              className={({ isActive }) =>
                `${styles.navLink} ${isActive ? styles['navLink--active'] : ''}`
              }
            >
              {label}
            </NavLink>
          </li>
        ))}
        <li className={styles.navItem}>
          <ChatReportMenuButton className={styles.navLink} onBeforeOpen={onNavigate} />
        </li>
        <li className={styles.navItem}>
          <button
            type='button'
            className={`${styles.navLink} ${styles.logoutButton}`}
            onClick={handleLogout}
          >
            Выход
          </button>
        </li>
      </ul>
    </>
  );
};
